import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type CPNavigationLoc =
	| 'CPNavigationCCIELabScheduler'
	| 'CPNavigationUserGuide'
	| 'CPNavigationSupportAndFaqs';

export const cpNavigationLocs: LocDefs<CPNavigationLoc> = {
	CPNavigationCCIELabScheduler: {
		defaultValue: 'CCIE Lab Scheduler',
		description: 'Menu item for the CCIE Lab Scheduler navigation item',
		displayPath: 'Navigation|CCIE Lab Scheduler',
		displayType: 'Content',
		portal: 'CP',
		feature: HubFeature.CiscoCustomReports,
	},
	CPNavigationUserGuide: {
		defaultValue: 'User Guide',
		description: 'Menu item for the User Guide navigation item',
		displayPath: 'Navigation|User Guide',
		displayType: 'Content',
		portal: 'CP',
		feature: HubFeature.CiscoCustomReports,
	},
	CPNavigationSupportAndFaqs: {
		defaultValue: 'Support and FAQs',
		description: 'Menu item for the Support and FAQs navigation item',
		displayPath: 'Navigation|Support and FAQs',
		displayType: 'Content',
		portal: 'CP',
	},
};

export const LOC_KEYS = MapLocKeys<CPNavigationLoc>(cpNavigationLocs);
export type CPNavigationLocType = LocMap<CPNavigationLoc>;
